"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15292],{

/***/ 209705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Textarea; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Textarea = (_a) => {
  var _b = _a, {
    title,
    value,
    rows = 4,
    placeholder,
    error,
    disabled,
    readonly,
    maxLength,
    autoFocus,
    defaultValue,
    onChange,
    onFocus,
    onBlur,
    onKeyDown
  } = _b, rest = __objRest(_b, [
    "title",
    "value",
    "rows",
    "placeholder",
    "error",
    "disabled",
    "readonly",
    "maxLength",
    "autoFocus",
    "defaultValue",
    "onChange",
    "onFocus",
    "onBlur",
    "onKeyDown"
  ]);
  const [isFocus, setIsFocus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const handleFocus = (e) => {
    !(readonly || disabled) && setIsFocus(true);
    !!onFocus && onFocus(e);
  };
  const handleBlur = (e) => {
    !(readonly || disabled) && setIsFocus(false);
    !!onBlur && onBlur(e);
  };
  const colorState = disabled ? "disable" : error ? "error500" : void 0;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTextareaWrapper, __spreadValues({}, rest), title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .SubTitle */ .DK, {
    level: 2,
    color: "textPrimary",
    marginBottom: "s4"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTextarea, {
    value,
    rows,
    placeholder,
    onChange: (event) => onChange && onChange(event.target.value),
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: (event) => {
      if (onKeyDown)
        onKeyDown(event);
    },
    readOnly: readonly,
    disabled,
    maxLength,
    autoFocus,
    defaultValue,
    isFocus,
    colorState
  }));
};
const StyledTextareaWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .CommonStyles */ .F}
`;
const StyledTextarea = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].textarea`
  resize: vertical;
  width: 100%;
  border: ${(p) => `1px solid ${p.isFocus ? p.theme.colors.link500 : p.theme.colors[p.colorState] || p.theme.colors.divider}`};
  border-radius: ${(p) => p.theme.borderRadius.s};
  padding: ${(p) => p.theme.spacing.s12};
  background-color: ${(p) => p.disabled ? p.theme.colors.background : p.theme.colors.white};
  font-size: 13px;
  color: ${(p) => p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary};
  &::placeholder {
    color: ${(p) => p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder};
  }
  &:focus {
    outline: none;
  }
`;




/***/ }),

/***/ 651337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ModalFooter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const ModalFooter = (_a) => {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, props), children);
};




/***/ }),

/***/ 514605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);



const StyledBar = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div((param)=>{
    let { barHeight , barBorder , theme , backgroundColor , justify  } = param;
    return "\n  height: ".concat(barHeight, "px;\n  border-radius: ").concat(barBorder, "px;\n  background-color: ").concat(backgroundColor || (theme === null || theme === void 0 ? void 0 : theme.colors.disable), ";\n  overflow: hidden;\n  position: relative;\n  margin: 0.25rem 0;\n  align-items: center;\n  justify-content: ").concat(justify, ";\n  display: flex;\n  width: 100%;\n");
});
const Progress = _teko_ds_mobile__WEBPACK_IMPORTED_MODULE_2__["default"].div((param)=>{
    let { height , border , progressPercentage , theme , color  } = param;
    return "\n  background-color: ".concat(color || (theme === null || theme === void 0 ? void 0 : theme.colors.primary), ";\n  position: absolute;\n  z-index: 1;\n  height: inherit;\n  border-radius: ").concat(border, "px;\n  height: ").concat(height, "px;\n  width: ").concat(progressPercentage, "%;\n  transition: width 0.3s ease-in-out;\n");
});
const ProgressBar = (param)=>{
    let { progress =0 , barColor , barHeight =4 , barBorder =barHeight / 2 , backgroundColor , barContent , justify  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledBar, {
        barHeight: barHeight,
        barBorder: barBorder,
        backgroundColor: backgroundColor,
        justify: justify,
        children: [
            barContent,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Progress, {
                progressPercentage: progress,
                color: barColor,
                height: barHeight,
                border: barBorder
            })
        ]
    });
};


/***/ }),

/***/ 661497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(252661);
/* harmony import */ var rc_select__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(144303);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  &.rc-select {\n    width: 100%;\n    } // don't remove this\n  }\n\n  .rc-select-selector {\n    height: ",
        ";\n    padding: 0 1rem;\n    display: flex;\n    align-items: center;\n  }\n\n  .rc-select-single {\n    .rc-select-selector {\n      .rc-select-selection-placeholder {\n        left: 5px;\n        color: ",
        ";\n      }\n      .rc-select-selection-item {\n        color: ",
        ";\n        left: 5px;\n      }\n    }\n  }\n\n  .rc-select-selection-placeholder,\n  .rc-select-selection-item {\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    margin-left: 0.5rem;\n  }\n\n  &.rc-select-single:not(.rc-select-customize-input) {\n    .rc-select-selector {\n      .rc-select-selection-search-input {\n        background: ",
        ";\n        padding: ",
        ";\n        height: 2.5rem;\n        border-radius: ",
        ";\n        border: 1px solid\n          ",
        ";\n        &:hover {\n          border-color: ",
        ";\n        }\n        :focus,\n        :focus-within {\n          border-color: ",
        ";\n        }\n      }\n    }\n  }\n\n  &.rc-select-single:not(.rc-select-customize-input) {\n    .rc-select-selector {\n      border-style: none !important;\n    }\n    .rc-select-clear {\n      margin-top: 0.75rem;\n    }\n  }\n\n  .rc-select-arrow {\n    right: 12px;\n    color: ",
        ";\n    display: flex;\n    align-items: center;\n  }\n\n  .rc-select-clear {\n    right: 13px;\n    background-color: ",
        ";\n    display: flex;\n    align-items: center;\n  }\n\n  .rc-select-dropdown {\n    margin-top: 4px;\n    padding: 0.25rem;\n    border-radius: ",
        ";\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n    border: none;\n    background-color: ",
        ";\n    min-height: auto;\n  }\n\n  .rc-select-item {\n    font-size: 13px;\n    padding: ",
        ";\n    height: 40px;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n\n  .rc-select-item-option-active,\n  .rc-select-item-option-selected {\n    background-color: ",
        ";\n    border-radius: ",
        ";\n  }\n\n  .rc-virtual-list,\n  .rc-virtual-list-holder,\n  .rc-virtual-list-holder-inner {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





const Select = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledSelect, _objectSpread({
        removeIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .DeleteCircleFilled */ .N, {
            color: "textSecondary",
            size: 16,
            className: "cursor-pointer"
        })
    }, props));
};
var _selectHeight, _selectInputPadding, _selectInputBorderRadius, _selectItemPadding;
const StyledSelect = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(rc_select__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_templateObject(), (p)=>(_selectHeight = p.selectHeight) !== null && _selectHeight !== void 0 ? _selectHeight : "40px", (p)=>p.disabled ? p.theme.colors.disable : p.theme.colors.placeholder, (p)=>p.disabled ? p.theme.colors.border : p.theme.colors.textPrimary, (p)=>p.disabled ? p.theme.colors.background : p.theme.colors.white, (p)=>(_selectInputPadding = p.selectInputPadding) !== null && _selectInputPadding !== void 0 ? _selectInputPadding : "0.25rem 2rem 0.25rem 0.75rem", (p)=>(_selectInputBorderRadius = p.selectInputBorderRadius) !== null && _selectInputBorderRadius !== void 0 ? _selectInputBorderRadius : p.theme.borderRadius.s, (p)=>p.disabled ? p.theme.colors.background : p.theme.colors.inputBorder, (param)=>{
    let { theme  } = param;
    return theme.colors.neutral;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.m;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (p)=>(_selectItemPadding = p.selectItemPadding) !== null && _selectItemPadding !== void 0 ? _selectItemPadding : "0.5rem 1rem", (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.background;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.s;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.m;
});


/***/ }),

/***/ 262665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CX": function() { return /* binding */ UPLOAD_VIDEO_PATHNAME; },
/* harmony export */   "dr": function() { return /* binding */ ACCEPTED_IMAGE_TYPES; },
/* harmony export */   "g9": function() { return /* binding */ UPLOAD_IMAGE_PATHNAME; },
/* harmony export */   "kI": function() { return /* binding */ UPLOAD_FILE_PRIVATE_PATHNAME; }
/* harmony export */ });
/* unused harmony exports UPLOAD_FILE_PATHNAME, UPLOAD_IMAGE_PRIVATE_PATHNAME */
const UPLOAD_IMAGE_PATHNAME = "/api/v2/upload/image?cloud=true&isPrivate=false";
const UPLOAD_FILE_PATHNAME = "/api/v2/upload/doc?cloud=true&isPrivate=false";
const UPLOAD_IMAGE_PRIVATE_PATHNAME = "/api/v2/upload/image?cloud=true&isPrivate=true";
const UPLOAD_FILE_PRIVATE_PATHNAME = "/api/v2/upload/doc?cloud=true&isPrivate=true";
const UPLOAD_VIDEO_PATHNAME = "/api/v2/upload/video?cloud=true&isPrivate=false";
const IMAGE_TYPE_PNG = "image/png";
const IMAGE_TYPE_JPEG = "image/jpeg";
const IMAGE_TYPE_JPG = "image/jpg";
const ACCEPTED_IMAGE_TYPES = [
    IMAGE_TYPE_JPEG,
    IMAGE_TYPE_JPG,
    IMAGE_TYPE_PNG, 
];


/***/ }),

/***/ 715292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ReviewSection": function() { return /* binding */ ReviewSection; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(329944);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/BlockHeader/BlockHeader.es.js
var BlockHeader_es = __webpack_require__(842918);
// EXTERNAL MODULE: ./contexts/ProductDetailContext.tsx + 3 modules
var ProductDetailContext = __webpack_require__(534924);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Flex/Flex.es.js
var Flex_es = __webpack_require__(387100);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Skeleton/Skeleton.es.js
var Skeleton_es = __webpack_require__(134128);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/configs/Colors/index.es.js
var Colors_index_es = __webpack_require__(743126);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/DownOutlined.es.js
var DownOutlined_es = __webpack_require__(925810);
// EXTERNAL MODULE: ./components/Select/Select.tsx
var Select = __webpack_require__(661497);
// EXTERNAL MODULE: ./modules/product-detail/shared/ProductReview/StarRating.tsx
var StarRating = __webpack_require__(111474);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(408797);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Video/Video.es.js
var Video_es = __webpack_require__(441363);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Image/Image.es.js
var Image_es = __webpack_require__(587021);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/RatingFilled.es.js
var RatingFilled_es = __webpack_require__(825078);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/UserProfileColored.es.js
var UserProfileColored_es = __webpack_require__(893555);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/PlayOutlined.es.js
var PlayOutlined_es = __webpack_require__(418536);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/ProductVideo/ProductVideo.es.js
var ProductVideo_es = __webpack_require__(7297);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/constants/index.es.js
var constants_index_es = __webpack_require__(875547);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.28.0-c19c5add1b-a0516b2e4f.zip/node_modules/date-fns/esm/format/index.js + 2 modules
var format = __webpack_require__(883667);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRating/ReviewItem.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background-color: #00000040;\n  align-items: center;\n  justify-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  display: block;\n  border-radius: 50%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  width: 60px;\n  height: 60px;\n  border-radius: 8px;\n  position: relative;\n  background: #000;\n  cursor: pointer;\n\n  video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








const Star = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFilled_es/* RatingFilled */.A, _objectSpread({
        size: 20,
        color: "#fcde04"
    }, props));
const ReviewItem = (param)=>{
    let { reviewData , showDivider ,  } = param;
    var ref, ref1, ref2, ref3;
    const { 0: previewVideo , 1: setPreviewVideo  } = (0,react.useState)(null);
    const { 0: previewImage , 1: setPreviewImage  } = (0,react.useState)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            align: "middle",
                            justify: "start",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                    children: reviewData.userAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleImageAvatar, {
                                        src: reviewData.userAvatar,
                                        width: 40,
                                        height: 40
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileColored_es/* UserProfileColored */.G, {
                                        size: 40,
                                        color: "white"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: "column",
                                    marginLeft: "s8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                            direction: "row",
                                            align: "center",
                                            gap: "s8",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                                                    level: 4,
                                                    children: reviewData.userName || (0,i18n.t)("Th\xe0nh vi\xean ẩn danh")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                                    level: 3,
                                                    color: "#00000073",
                                                    children: (0,format/* default */.Z)(new Date(reviewData.createdAt * 1000), "dd/MM/yyyy HH:mm")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                                            value: reviewData.review.rating,
                                            starSize: 13
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            weight: "regular",
                            marginTop: "s12",
                            children: reviewData.review.comment
                        }),
                        !!((ref = reviewData.review.images) === null || ref === void 0 ? void 0 : ref.length) || !!((ref1 = reviewData.review.videos) === null || ref1 === void 0 ? void 0 : ref1.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "row",
                            gap: "s4",
                            marginTop: "s4",
                            align: "center",
                            children: [
                                (ref2 = reviewData.review.videos) === null || ref2 === void 0 ? void 0 : ref2.map((videoUrl, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMedia, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoThumbnail, {
                                            onClick: ()=>setPreviewVideo(videoUrl),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_es/* Video */.n, {
                                                    src: videoUrl,
                                                    muted: true,
                                                    width: "100%",
                                                    height: "60px",
                                                    playsInline: true,
                                                    autoPlay: true,
                                                    preload: "metadata"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIconOverlay, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayOutlined_es/* PlayOutlined */.n, {
                                                        color: "white",
                                                        size: 28
                                                    })
                                                })
                                            ]
                                        })
                                    }, index)),
                                (ref3 = reviewData.review.images) === null || ref3 === void 0 ? void 0 : ref3.map((imageUrl, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMedia, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                                            src: imageUrl,
                                            width: "100%",
                                            height: "100%",
                                            borderRadius: "8px",
                                            onClick: ()=>setPreviewImage(imageUrl)
                                        })
                                    }, index))
                            ]
                        }) : null
                    ]
                })
            }),
            !!showDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                color: "divider"
            }),
            previewVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                visible: !!previewVideo,
                onClose: ()=>setPreviewVideo(null),
                width: "max-content",
                showCloseIcon: true,
                centeredBody: true,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo_es/* ProductVideo */.N, {
                    url: previewVideo,
                    source: constants_index_es/* SOURCE_VIDEO.SYSTEM */.Ok.SYSTEM,
                    videoProps: {
                        width: "100%",
                        controls: true,
                        autoPlay: true,
                        style: {
                            maxWidth: "80vw",
                            maxHeight: "80vh"
                        }
                    }
                })
            }),
            previewImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                visible: !!previewImage,
                onClose: ()=>setPreviewImage(null),
                width: "max-content",
                showCloseIcon: true,
                footer: null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                    src: previewImage,
                    width: "100%",
                    style: {
                        maxWidth: "80vw",
                        maxHeight: "80vh"
                    }
                })
            })
        ]
    });
};
const Avatar = emotion_styled_browser_esm["default"].div(_templateObject());
const StyledMedia = emotion_styled_browser_esm["default"].div(_templateObject1());
const StyleImageAvatar = (0,emotion_styled_browser_esm["default"])(Image_es/* Image */.E)(_templateObject2());
const VideoThumbnail = emotion_styled_browser_esm["default"].div(_templateObject3());
const PlayIconOverlay = emotion_styled_browser_esm["default"].div(_templateObject4());

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(806748);
;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRating/ViewMoreReviewsButton.tsx



const ViewMoreReviewsButton = (param)=>{
    let { onClick , numberOfReviews ,  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
        align: "center",
        justify: "center",
        marginTop: "s24",
        marginBottom: "s16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
            variant: "link",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                level: 1,
                children: (0,i18n.t)("Xem th\xeam {{numberOfReviews}} đ\xe1nh gi\xe1", {
                    numberOfReviews
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./modules/product-detail/desktop/DetailPageSGC/ProductRating/ProductRatingList.tsx









const STAR_RATING = [
    5,
    4,
    3,
    2,
    1
];
const ProductRatingList = (param)=>{
    let { ratingData ,  } = param;
    const { data , reviews , hasMore , loadMore , noFilter , filterParams , setFilterParams , numberOfReviewsRemaining , setPage , isValidating ,  } = ratingData;
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const isSmallScreen = window.innerWidth < 360;
    return data ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        backgroundColor: "white",
        padding: [
            "s16",
            "s8"
        ],
        paddingTop: "s0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlex, {
                gap: "s8",
                paddingBottom: "s16",
                children: [
                    !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Title */.Dx, {
                        marginRight: "s8",
                        children: [
                            (0,i18n.t)("Lọc đ\xe1nh gi\xe1"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTab, {
                        isActive: noFilter,
                        onClick: ()=>{
                            setFilterParams(undefined);
                            setPage(1);
                        },
                        children: (0,i18n.t)("Tất cả")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTab, {
                        isActive: filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasImage,
                        onClick: ()=>{
                            setFilterParams({
                                hasImage: true
                            });
                            setPage(1);
                        },
                        children: (0,i18n.t)("C\xf3 h\xecnh ảnh")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTab, {
                        isActive: filterParams === null || filterParams === void 0 ? void 0 : filterParams.hasVideo,
                        onClick: ()=>{
                            setFilterParams({
                                hasVideo: true
                            });
                            setPage(1);
                        },
                        children: (0,i18n.t)("C\xf3 video")
                    }),
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                        placeholder: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                            direction: "row",
                            gapX: "s4",
                            align: "center",
                            children: [
                                (0,i18n.t)("Sao"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                    size: 16
                                })
                            ]
                        }),
                        options: STAR_RATING.map((star)=>({
                                value: star,
                                label: isSmallScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                    direction: "row",
                                    gapX: "s4",
                                    align: "center",
                                    children: [
                                        star,
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                            size: 16
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                                    value: star,
                                    max: star,
                                    starSize: 15
                                })
                            })),
                        defaultValue: filterParams === null || filterParams === void 0 ? void 0 : filterParams.rating,
                        labelRender: (item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                direction: "row",
                                gapX: "s4",
                                align: "center",
                                children: [
                                    item.value,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                        size: 16
                                    })
                                ]
                            }),
                        suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined_es/* DownOutlined */.T, {
                            size: 18,
                            style: {
                                marginTop: "11px"
                            }
                        }),
                        onSelect: (value)=>{
                            setFilterParams({
                                rating: value
                            });
                            setPage(1);
                        },
                        onInputKeyDown: (e)=>{
                            e.preventDefault();
                        },
                        menuItemSelectedIcon: null,
                        notFoundContent: null,
                        selectItemPadding: !isSmallScreen ? "0 0.25rem" : "0 1rem",
                        selectHeight: "36px",
                        style: {
                            border: "1px solid #E4E5F0",
                            borderRadius: "1rem"
                        }
                    }) : STAR_RATING.map((star, index)=>{
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterTab, {
                            isActive: (filterParams === null || filterParams === void 0 ? void 0 : filterParams.rating) === star,
                            onClick: ()=>{
                                setFilterParams({
                                    rating: star
                                });
                                setPage(1);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                direction: "row",
                                gapX: "s4",
                                align: "center",
                                children: [
                                    star,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Star, {
                                        size: 16
                                    })
                                ]
                            })
                        }, index);
                    })
                ]
            }),
            isValidating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_es/* Skeleton */.O, {
                height: "0.75rem",
                width: "80%",
                marginTop: "s16"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: reviews.length ? reviews.map((review, index)=>review ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewItem, {
                        reviewData: review,
                        showDivider: index < reviews.length - 1
                    }, index) : null) : null
            }),
            hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMoreReviewsButton, {
                onClick: loadMore,
                numberOfReviews: numberOfReviewsRemaining
            }) : null
        ]
    }) : null;
};
const FilterTab = emotion_styled_browser_esm["default"].div((param)=>{
    let { isActive  } = param;
    return "\n  padding: 8px;\n  border: 1px solid ".concat(isActive ? "#0200BC" : Colors_index_es/* themeColor.divider */.E.divider, ";\n  background-color: ").concat(isActive ? "#0200BC1A" : "#fff", ";\n  border-radius: 16px;\n  color: ").concat(isActive ? "#0200BC" : "black", ";\n  font-size: 12px;\n  line-height: 20px;\n  font-weight: 400;\n  align-items: center;\n  justify-self: center;\n  white-space: nowrap;\n  cursor: pointer;\n");
});
const StyledFlex = (0,emotion_styled_browser_esm["default"])(Flex_es/* Flex */.k)(()=>"\n  max-width: 90vw;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scroll-behavior: smooth; \n  scrollbar-width: none;\n  -ms-overflow-style: none;\n");

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/hook.es.js
var hook_es = __webpack_require__(339674);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Loading/Loading.es.js
var Loading_es = __webpack_require__(80912);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(212808);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(670894);
;// CONCATENATED MODULE: ./assets/product-no-rating.svg
/* harmony default export */ var product_no_rating = ("https://shopfront-cdn.tekoapis.com/_next/static/images/product-no-rating-0e8d9f3c324bf25bf643ac795de27ba4.svg");
// EXTERNAL MODULE: ./components/ProgressBar.tsx
var ProgressBar = __webpack_require__(514605);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-desktop-virtual-3875a8f4e3/1/packages/ds-desktop/dist/components/Toast/hooks.es.js
var hooks_es = __webpack_require__(314408);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Form/index.es.js + 23 modules
var Form_index_es = __webpack_require__(826373);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Textarea.es.js
var Textarea_es = __webpack_require__(209705);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(651337);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ./constants/file.ts
var constants_file = __webpack_require__(262665);
// EXTERNAL MODULE: ./services/consumer.ts
var consumer = __webpack_require__(667913);
// EXTERNAL MODULE: ../../packages/auth/dist/interceptor.es.js
var interceptor_es = __webpack_require__(847143);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-4bc8ec0ac6/1/packages/ds-icon/dist/components/CloseOutlined.es.js
var CloseOutlined_es = __webpack_require__(676662);
;// CONCATENATED MODULE: ./assets/upload-file.svg
/* harmony default export */ var upload_file = ("data:image/svg+xml;base64,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");
// EXTERNAL MODULE: ../../.yarn/__virtual__/rc-upload-virtual-1aa0cc9cf4/0/cache/rc-upload-npm-4.11.0-6bf0a45901-6828051d49.zip/node_modules/rc-upload/es/index.js + 6 modules
var es = __webpack_require__(822295);
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/MediaUploader.tsx
function MediaUploader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MediaUploader_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MediaUploader_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









const MediaUploader = (_param)=>{
    var { children , fileList , maxItems =5 , onDelete  } = _param, restProps = _objectWithoutProperties(_param, [
        "children",
        "fileList",
        "maxItems",
        "onDelete"
    ]);
    const { getProcessEnv , isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const baseFileServiceUrl = getProcessEnv("BASE_FILE_SERVICE_API_URL");
    const uploaderProps = {
        action: (file)=>{
            if (file.type.includes("image")) return "".concat(baseFileServiceUrl).concat(constants_file/* UPLOAD_IMAGE_PATHNAME */.g9);
            return "".concat(baseFileServiceUrl).concat(constants_file/* UPLOAD_VIDEO_PATHNAME */.CX);
        },
        name: "file",
        accept: "image/*,video/*",
        multiple: true,
        headers: {
            Authorization: "Bearer ".concat((0,interceptor_es/* getAccessToken */.h)())
        }
    };
    const isExceededMaxItems = typeof maxItems === "number" && !!(fileList === null || fileList === void 0 ? void 0 : fileList.length) && fileList.length >= maxItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
            gap: isMobile ? "s4" : "s12",
            align: "start",
            flexWrap: "wrap",
            children: [
                fileList === null || fileList === void 0 ? void 0 : fileList.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(ItemsWrapper, {
                        isMobile: isMobile,
                        children: [
                            item.type === "image" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                                src: (item === null || item === void 0 ? void 0 : item.image_url) || (item === null || item === void 0 ? void 0 : item.url) || "",
                                style: {
                                    borderRadius: 6,
                                    cursor: "pointer",
                                    width: "100%",
                                    height: isMobile ? "55px" : "60px"
                                },
                                objectFit: "cover"
                            }),
                            item.type === "video" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductVideo_es/* ProductVideo */.N, {
                                url: item.url,
                                source: constants_index_es/* SOURCE_VIDEO.SYSTEM */.Ok.SYSTEM,
                                videoProps: {
                                    width: "100%",
                                    height: "100%",
                                    preload: "none",
                                    playsInline: true,
                                    autoPlay: true,
                                    muted: true,
                                    controls: isMobile ? false : true
                                }
                            }),
                            item.status === "done" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    top: "1px",
                                    right: "4px"
                                },
                                onClick: ()=>onDelete(item.url),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined_es/* CloseOutlined */.X, {
                                    size: 16,
                                    color: "#A7ABC3"
                                })
                            }),
                            item.status === "uploading" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    position: "absolute",
                                    inset: 0,
                                    background: "rgba(0,0,0,0.4)",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 6
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                                    isLoading: true,
                                    size: 24
                                })
                            })
                        ]
                    }, index);
                }),
                !isExceededMaxItems && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, _objectSpreadProps(MediaUploader_objectSpread({}, uploaderProps, restProps), {
                    children: !!(fileList === null || fileList === void 0 ? void 0 : fileList.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsWrapper, {
                        style: {
                            display: "flex",
                            alignItems: "center"
                        },
                        isMobile: isMobile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            src: upload_file,
                            imageWidth: 48
                        })
                    }) : children
                }))
            ]
        })
    });
};
const ItemsWrapper = emotion_styled_browser_esm["default"].div((param)=>{
    let { isMobile  } = param;
    return "\n  position: relative;\n  width: ".concat(isMobile ? "55px" : "60px", ";\n  height: ").concat(isMobile ? "55px" : "60px", ";\n  border-radius: 6px;\n  border: 1px solid #d9d9d9;\n");
});

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/ProductReview.tsx
function ProductReview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductReview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductReview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductReview_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ProductReview_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ProductReview_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ProductReview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductReview_templateObject() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  width: 40px;\n  height: 30px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-self: center;\n"
    ]);
    ProductReview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductReview_templateObject1() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    ProductReview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductReview_templateObject2() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  display: block;\n"
    ]);
    ProductReview_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductReview_templateObject3() {
    const data = ProductReview_taggedTemplateLiteral([
        "\n  line-height: 22px;\n  font-size: 14px;\n"
    ]);
    ProductReview_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










const MAXIMUM_COMMENT_LENGTH = 2000;
const MAX_NUMBER_OF_MEDIA_ITEMS = 5;
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const ProductReview = (param)=>{
    let { visible , onCloseModal , openSuccessModal , refetchReviewList ,  } = param;
    var ref;
    const toast = (0,hooks_es/* useToast */.p)();
    const [form] = Form_index_es/* Form.useForm */.l.useForm();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { product  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { 0: rating , 1: setRating  } = (0,react.useState)();
    const { 0: commentLength , 1: setCommentLength  } = (0,react.useState)(0);
    const { 0: fileList , 1: setFileList  } = (0,react.useState)([]);
    const toastShownRef = (0,react.useRef)(false);
    const isUploading = fileList.some((file)=>file.status === "uploading");
    const handleBeforeUpload = (file, fileListIncoming)=>{
        var ref;
        const incoming = (ref = fileListIncoming === null || fileListIncoming === void 0 ? void 0 : fileListIncoming.length) !== null && ref !== void 0 ? ref : 1;
        if (fileList.length + incoming > MAX_NUMBER_OF_MEDIA_ITEMS) {
            if (!toastShownRef.current) {
                var ref1;
                toastShownRef.current = true;
                toast === null || toast === void 0 ? void 0 : (ref1 = toast.error) === null || ref1 === void 0 ? void 0 : ref1.call(toast, {
                    title: (0,i18n.t)("Cảnh b\xe1o"),
                    placement: "topRight",
                    message: (0,i18n.t)("Cho ph\xe9p tối đa {{maxNumber}} ảnh/video.", {
                        maxNumber: MAX_NUMBER_OF_MEDIA_ITEMS
                    })
                });
                setTimeout(()=>{
                    toastShownRef.current = false;
                }, 0);
            }
            return false;
        }
        if (!file.type || !constants_file/* ACCEPTED_IMAGE_TYPES.includes */.dr.includes(file.type) && !file.type.startsWith("video")) {
            var ref2;
            toast === null || toast === void 0 ? void 0 : (ref2 = toast.error) === null || ref2 === void 0 ? void 0 : ref2.call(toast, {
                title: (0,i18n.t)("C\xf3 lỗi"),
                placement: "topRight",
                message: (0,i18n.t)("File kh\xf4ng hợp lệ")
            });
            return false;
        }
        if (file.size > MAX_FILE_SIZE) {
            var ref3;
            toast === null || toast === void 0 ? void 0 : (ref3 = toast.error) === null || ref3 === void 0 ? void 0 : ref3.call(toast, {
                title: (0,i18n.t)("C\xf3 lỗi"),
                placement: "topRight",
                message: (0,i18n.t)("File kh\xf4ng được vượt qu\xe1 {{max}}MB", {
                    max: 10
                })
            });
            return false;
        }
        const url = URL.createObjectURL(file);
        const isImage = file.type.startsWith("image/");
        const isVideo = file.type.startsWith("video/");
        setFileList((prev)=>[
                ...prev,
                {
                    file,
                    url,
                    type: isImage ? "image" : isVideo ? "video" : "other",
                    status: "uploading"
                }, 
            ]);
        return true;
    };
    const uploaderProps = {
        beforeUpload: handleBeforeUpload,
        onSuccess: (res, file)=>{
            setFileList((prev)=>prev.map((item)=>item.file === file ? ProductReview_objectSpreadProps(ProductReview_objectSpread({}, item), {
                        status: "done",
                        url: res.url,
                        image_url: res.image_url
                    }) : item));
        },
        onDelete: (fileUrl)=>setFileList(fileList.filter((file)=>file.url !== fileUrl)),
        fileList,
        onError (_, file) {
            const newFileList = fileList.filter((item)=>item.file.uid === file.uid);
            setFileList(newFileList);
        },
        maxItems: MAX_NUMBER_OF_MEDIA_ITEMS
    };
    const handleCreateProductReview = async ()=>{
        var ref, ref1;
        if ((product === null || product === void 0 ? void 0 : (ref = product.productGroup) === null || ref === void 0 ? void 0 : ref.id) && ((ref1 = product.seller) === null || ref1 === void 0 ? void 0 : ref1.id) && rating) {
            const getMediaUrls = (type)=>{
                return fileList.filter((file)=>file.type === type).map((item)=>item.url);
            };
            try {
                var ref2;
                const payload = {
                    productUrl: window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.href,
                    rating,
                    sellerId: product.seller.id,
                    review: {
                        comment: form.getFieldValue("comment"),
                        images: getMediaUrls("image"),
                        videos: getMediaUrls("video")
                    }
                };
                await (0,consumer/* createProductReview */.nE)(product.productGroup.id, payload);
                onCloseModal();
                openSuccessModal();
                refetchReviewList();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                var ref3, ref4, ref5;
                const traceId = e === null || e === void 0 ? void 0 : (ref3 = e.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.error) === null || ref4 === void 0 ? void 0 : ref4.traceId;
                (ref5 = toast.error) === null || ref5 === void 0 ? void 0 : ref5.call(toast, {
                    title: (0,i18n.t)("C\xf3 lỗi"),
                    message: "[".concat(traceId, "] ").concat((0,i18n.t)("C\xf3 lỗi xảy ra. Vui l\xf2ng thử lại sau!"))
                });
                dist_index_es/* logger.error */.k.error("Error occur when createProductReview: ".concat(e));
            }
        } else {
            var ref6, ref7;
            dist_index_es/* logger.error */.k.error("Missing productId or sellerId or rating", product === null || product === void 0 ? void 0 : (ref6 = product.productGroup) === null || ref6 === void 0 ? void 0 : ref6.id, product === null || product === void 0 ? void 0 : (ref7 = product.seller) === null || ref7 === void 0 ? void 0 : ref7.id, rating);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
        visible: visible,
        borderRadius: "16px",
        width: isMobile ? "90%" : 480,
        showCloseIcon: true,
        onClose: onCloseModal,
        okText: "",
        cancelText: "",
        contentStyle: {
            padding: 0
        },
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                children: (0,i18n.t)("Đ\xe1nh gi\xe1 sản phẩm")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody_es/* ModalBody */.f, {
                paddingLeft: "s16",
                paddingRight: "s16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                        border: "1px solid divider",
                        borderRadius: "m",
                        align: "center",
                        padding: "s8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleImage, {
                                    src: (product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : ref[0].src) || ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                                direction: "column",
                                marginLeft: "s16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Caption */.YS, {
                                    level: 2,
                                    children: product === null || product === void 0 ? void 0 : product.displayName
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
                        marginTop: "s16",
                        padding: [
                            "s16",
                            "s24"
                        ],
                        backgroundColor: "#fafafa",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                align: "center",
                                justify: "center",
                                direction: "column",
                                marginBottom: "s24",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        level: 1,
                                        marginBottom: "s8",
                                        children: (0,i18n.t)("Bạn c\xf3 h\xe0i l\xf2ng về sản phẩm?")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReview_StarRating, {
                                        children: Array(5).fill(null).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFilled_es/* RatingFilled */.A, {
                                                size: isMobile ? 28 : 32,
                                                style: {
                                                    marginLeft: "0.5rem",
                                                    marginRight: "0.5rem"
                                                },
                                                onClick: ()=>setRating(index + 1),
                                                color: rating && index + 1 <= rating ? "#fcde04" : "#C4D1FF80"
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form */.l, {
                                layout: "vertical",
                                form: form,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_index_es/* Form.Item */.l.Item, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        level: 1,
                                        children: (0,i18n.t)("Chia sẻ nhận x\xe9t về sản phẩm")
                                    }),
                                    style: {
                                        marginBottom: 0
                                    },
                                    name: "comment",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea_es/* Textarea */.g, {
                                        rows: 4,
                                        borderRadius: "l",
                                        maxLength: MAXIMUM_COMMENT_LENGTH,
                                        onChange: (value)=>setCommentLength(value.length)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                                justify: "space-between",
                                align: "start",
                                marginTop: "s0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaUploader, ProductReview_objectSpreadProps(ProductReview_objectSpread({}, uploaderProps), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                            level: 1,
                                            color: "link",
                                            children: (0,i18n.t)("Th\xeam ảnh/video")
                                        })
                                    })),
                                    (!isMobile || fileList.length < MAX_NUMBER_OF_MEDIA_ITEMS - 1) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBody, {
                                        level: 1,
                                        color: "#8C8C8C",
                                        children: "".concat(commentLength, "/").concat(MAXIMUM_COMMENT_LENGTH)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter_es/* ModalFooter */.m, {
                paddingLeft: "s40",
                paddingRight: "s40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    width: "100%",
                    variant: "primary",
                    borderRadius: "m",
                    onClick: handleCreateProductReview,
                    disabled: isUploading,
                    children: (0,i18n.t)("Gửi đ\xe1nh gi\xe1")
                })
            })
        ]
    });
};
const ProductImage = emotion_styled_browser_esm["default"].div(ProductReview_templateObject());
const ProductReview_StarRating = emotion_styled_browser_esm["default"].div(ProductReview_templateObject1());
const StyleImage = (0,emotion_styled_browser_esm["default"])(Image_es/* Image */.E)(ProductReview_templateObject2());
const StyledBody = (0,emotion_styled_browser_esm["default"])(Typography_index_es/* Body */.uT)(ProductReview_templateObject3());

;// CONCATENATED MODULE: ./assets/thank-for-rating.svg
/* harmony default export */ var thank_for_rating = ("data:image/svg+xml;base64,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");
;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/RatingSuccessModal.tsx
function RatingSuccessModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RatingSuccessModal_templateObject() {
    const data = RatingSuccessModal_taggedTemplateLiteral([
        "\n  width: 64px;\n  height: 64px;\n"
    ]);
    RatingSuccessModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RatingSuccessModal_templateObject1() {
    const data = RatingSuccessModal_taggedTemplateLiteral([
        "\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n"
    ]);
    RatingSuccessModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





const DURATION = 5;
const RatingSuccessModal = (param)=>{
    let { show , onClose ,  } = param;
    const { 1: setSecondsLeft  } = (0,react.useState)(DURATION); // auto close modal after 5s
    const { 0: running , 1: setRunning  } = (0,react.useState)(true);
    const timerRef = (0,react.useRef)();
    // Reset when modal opens/closes or duration changes
    (0,react.useEffect)(()=>{
        if (show) {
            setSecondsLeft(DURATION);
            setRunning(true);
        } else {
            setRunning(false);
            clearInterval(timerRef.current);
        }
        return ()=>clearInterval(timerRef.current);
    }, [
        show
    ]);
    // Start / stop interval
    (0,react.useEffect)(()=>{
        clearInterval(timerRef.current);
        if (!show) return;
        if (!running) return;
        timerRef.current = setInterval(()=>{
            setSecondsLeft((s)=>{
                if (s <= 1) {
                    // time's up: close modal
                    clearInterval(timerRef.current);
                    // call onClose on the next tick so UI updates cleanly
                    onClose();
                    return 0;
                }
                return s - 1;
            });
        }, 1000);
        return ()=>clearInterval(timerRef.current);
    }, [
        running,
        show,
        onClose
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
        visible: show,
        borderRadius: "l",
        width: 446,
        contentStyle: {
            padding: 0
        },
        okText: "",
        cancelText: "",
        showCloseIcon: false,
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBody_es/* ModalBody */.f, {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_es/* Image */.E, {
                            src: thank_for_rating,
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: (0,i18n.t)("Cảm ơn bạn đ\xe3 đ\xe1nh gi\xe1!")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter_es/* ModalFooter */.m, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                    width: "100%",
                    variant: "primary",
                    borderRadius: "m",
                    onClick: ()=>{
                        onClose();
                        setRunning(false);
                        clearInterval(timerRef.current);
                    },
                    children: (0,i18n.t)("Đ\xf3ng")
                })
            })
        ]
    });
};
const ImageWrapper = emotion_styled_browser_esm["default"].div(RatingSuccessModal_templateObject());
const Text = emotion_styled_browser_esm["default"].div(RatingSuccessModal_templateObject1());

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/RatingOverview.tsx
function RatingOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RatingOverview_templateObject() {
    const data = RatingOverview_taggedTemplateLiteral([
        "\n  .button-text {\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 24px;\n  }\n"
    ]);
    RatingOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












const RatingOverview = (param)=>{
    let { ratingData ,  } = param;
    const { isMobile , epicOmni1550HideReviewButton  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { showModal  } = (0,hook_es/* useModal */.d)();
    const { user , authService  } = (0,context_es/* useAuth */.aC)();
    const { 0: showProductReview , 1: setShowProductReview  } = (0,react.useState)(false);
    const { 0: showRatingSuccessModal , 1: setShowRatingSuccessModal  } = (0,react.useState)(false);
    const { averageRating , totalReviews , ratingCounts , setFilterParams , setPage , refreshReviewList ,  } = ratingData;
    const sortedRatingCounts = (0,react.useMemo)(()=>{
        return ratingCounts === null || ratingCounts === void 0 ? void 0 : ratingCounts.sort((a, b)=>b.star - a.star);
    }, [
        ratingCounts
    ]);
    const handleUnauthenticatedUser = ()=>{
        showModal({
            size: "m",
            title: (0,i18n.t)("Th\xf4ng b\xe1o"),
            centeredTitle: true,
            okText: (0,i18n.t)("Đăng nhập"),
            cancelText: (0,i18n.t)("Đ\xf3ng"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex_es/* Flex */.k, {
                direction: "column",
                align: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                    marginTop: "s4",
                    children: (0,i18n.t)("Vui l\xf2ng đăng nhập để đ\xe1nh gi\xe1 sản phẩm.")
                })
            }),
            alignFooter: "center",
            onOk: ()=>authService.login()
        });
    };
    const writeProductReview = ()=>{
        if (!(user === null || user === void 0 ? void 0 : user.userId)) {
            handleUnauthenticatedUser();
            return;
        }
        setShowProductReview(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                padding: "s8",
                backgroundColor: "white",
                children: ratingData.isValidating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading_es/* Loading */.g, {
                    isLoading: true,
                    size: 40
                }) : !!totalReviews ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                    justify: "center",
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            span: !isMobile ? 2 : 12,
                            style: {
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                align: "middle",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col_es/* Col */.JX, {
                                        span: !isMobile ? 12 : 6,
                                        style: {
                                            alignItems: "center",
                                            justifyItems: !isMobile ? "center" : "start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Heading */.X6, {
                                                marginRight: "s4",
                                                weight: "bold",
                                                style: {
                                                    fontSize: "40px",
                                                    lineHeight: "56px"
                                                },
                                                children: [
                                                    averageRating,
                                                    "/5"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRating/* StarRating */.Z, {
                                                value: averageRating || 0,
                                                starSize: 20,
                                                gap: 8
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                                marginTop: "s8",
                                                weight: "regular",
                                                children: [
                                                    totalReviews,
                                                    " ",
                                                    (0,i18n.t)("lượt đ\xe1nh gi\xe1")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        span: !isMobile ? 12 : 6,
                                        style: {
                                            display: "flex",
                                            justifyContent: !isMobile ? "center" : "end"
                                        },
                                        marginTop: "s8",
                                        children: !epicOmni1550HideReviewButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReviewButton, {
                                            variant: "primary",
                                            borderRadius: "m",
                                            onClick: writeProductReview,
                                            children: (0,i18n.t)("Viết đ\xe1nh gi\xe1")
                                        })
                                    })
                                ]
                            })
                        }),
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                            color: "divider",
                            orientation: "vertical",
                            width: "100px"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            span: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                                color: "divider",
                                orientation: "horizontal"
                            })
                        }),
                        sortedRatingCounts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                            span: !isMobile ? 8 : 12,
                            children: sortedRatingCounts.map((item)=>{
                                const percent = totalReviews > 0 ? item.count / totalReviews * 100 : 0;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                    align: "middle",
                                    justify: "start",
                                    margin: [
                                        "s8",
                                        "s0"
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                            span: 1,
                                            marginRight: "s8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                                                align: "middle",
                                                justify: "end",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                                                        marginRight: "s4",
                                                        weight: "medium",
                                                        children: item.star
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingFilled_es/* RatingFilled */.A, {
                                                        size: 14,
                                                        color: "support"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                            span: !isMobile ? 7 : 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar/* ProgressBar */.k, {
                                                barHeight: 8,
                                                progress: percent,
                                                backgroundColor: Colors_index_es/* themeColor.divider */.E.divider,
                                                barColor: "#0300be"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                            span: !isMobile ? 3.5 : 4,
                                            marginLeft: "s8",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography_index_es/* Body */.uT, {
                                                weight: "regular",
                                                children: [
                                                    item.count,
                                                    " ",
                                                    (0,i18n.t)("lượt đ\xe1nh gi\xe1")
                                                ]
                                            })
                                        })
                                    ]
                                }, item.star);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton_es/* Skeleton */.O, {
                            height: "0.75rem",
                            width: "50%"
                        })
                    ]
                }) : !epicOmni1550HideReviewButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex_es/* Flex */.k, {
                    direction: "column",
                    align: "center",
                    gap: "s16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyImage_es/* LazyImage */.w, {
                            src: product_no_rating,
                            width: 160,
                            height: 93
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                            weight: isMobile ? "regular" : "medium",
                            style: {
                                fontSize: isMobile ? 13 : 15
                            },
                            children: (0,i18n.t)("H\xe3y trở th\xe0nh người đầu ti\xean đ\xe1nh gi\xe1 sản phẩm n\xe0y")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteReviewButton, {
                            variant: "primary",
                            borderRadius: "m",
                            onClick: writeProductReview,
                            children: (0,i18n.t)("Viết đ\xe1nh gi\xe1")
                        })
                    ]
                })
            }),
            !!showProductReview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReview, {
                visible: showProductReview,
                onCloseModal: ()=>setShowProductReview(false),
                openSuccessModal: ()=>setShowRatingSuccessModal(true),
                refetchReviewList: ()=>{
                    setFilterParams(undefined);
                    setPage(1);
                    refreshReviewList();
                }
            }),
            !!showRatingSuccessModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingSuccessModal, {
                show: showRatingSuccessModal,
                onClose: ()=>setShowRatingSuccessModal(false)
            })
        ]
    });
};
const WriteReviewButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)(RatingOverview_templateObject());

;// CONCATENATED MODULE: ./modules/product-detail/shared/ProductReview/ReviewSection.tsx
function ReviewSection_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ReviewSection_templateObject() {
    const data = ReviewSection_taggedTemplateLiteral([
        "\n  border-bottom: 1px solid #ebeaea;\n"
    ]);
    ReviewSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








const ReviewSection = ()=>{
    var ref;
    const { productRatingData  } = (0,ProductDetailContext/* useProductDetailState */.W)();
    const { epicOmni1550HideReviewButton  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    // Hide review section when this config on & no rating data
    if (epicOmni1550HideReviewButton && !((ref = productRatingData.data) === null || ref === void 0 ? void 0 : ref.reviews.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Shape */.b, {
        id: "review-section",
        backgroundColor: "white",
        borderRadius: "xl",
        padding: "s8",
        margin: [
            "s8",
            "s0"
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlockHeader, {
                title: (0,i18n.t)("Đ\xe1nh gi\xe1")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingOverview, {
                ratingData: productRatingData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                color: "divider",
                gap: "16px"
            }),
            !!productRatingData.totalReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRatingList, {
                ratingData: productRatingData
            })
        ]
    });
};
const StyledBlockHeader = (0,emotion_styled_browser_esm["default"])(BlockHeader_es/* BlockHeader */.t)(ReviewSection_templateObject());


/***/ })

}]);